module.exports = __webpack_public_path__ + "img/super_hero.8d5f5d84.png";